import ApiClient from './ApiClient';

// QM §5.3 — admin CRUD. Endpoints wired in config/routes.rb
// under `resources :queues`. The controller expects params nested under `queue`,
// so create/update wrap the payload here.
class QueuesAPI extends ApiClient {
  constructor() {
    super('queues', { accountScoped: true });
  }

  create(queueObj) {
    return axios.post(this.url, { queue: queueObj });
  }

  update(id, queueObj) {
    return axios.patch(`${this.url}/${id}`, { queue: queueObj });
  }

  // QM §5.4.3 mode 2 — waiting tickets in FIFO order (browse-and-pick source).
  // QM §5.10 — paged; the response carries { payload, meta }.
  getConversations(queueId, page = 1) {
    return axios.get(`${this.url}/${queueId}/conversations`, {
      params: { page },
    });
  }

  // QM §5.5.2 — assigned tickets residing in the queue (supervisor drill-down).
  // QM §5.10 — paged, same shape as above.
  getAssignedConversations(queueId, page = 1) {
    return axios.get(`${this.url}/${queueId}/assigned_conversations`, {
      params: { page },
    });
  }

  // QM §5.5.2 — agents in the queue's routing groups with their load and cap.
  getAgents(queueId) {
    return axios.get(`${this.url}/${queueId}/agents`);
  }

  // §5.4.3 mode 1 — "Take Next" self-take.
  takeNext(queueId, confirmed = false) {
    return axios.post(`${this.url}/${queueId}/take_next`, { confirmed });
  }

  // QM §5.5.1 — supervisor tile counts for every queue in the account.
  getOverview() {
    return axios.get(`${this.url}/overview`);
  }

  // QM §5.4.2 — tickets owned by the calling agent, already in the PRD's default order.
  getMyTickets() {
    return axios.get(`${this.url}/my_tickets`);
  }
}

export default new QueuesAPI();
